import { createAtomObserver } from '@exodus/atoms';
const applicationLifecyclePlugin = ({ port, lockedAtom, lockHistoryAtom, restoreAtom, }) => {
    const observers = [
        createAtomObserver({ port, atom: lockedAtom, event: 'locked' }),
        createAtomObserver({ port, atom: lockHistoryAtom, event: 'lockHistory' }),
        createAtomObserver({ port, atom: restoreAtom, event: 'restore' }),
    ];
    const onStart = ({ isRestoring }) => {
        restoreAtom.set(isRestoring);
    };
    const onLoad = async () => {
        observers.forEach((observer) => observer.start());
    };
    const onImport = () => {
        restoreAtom.set(true);
    };
    const onAssetsSynced = async () => {
        restoreAtom.set(false);
    };
    const onStop = () => {
        observers.forEach((observer) => observer.unregister());
    };
    return { onStart, onLoad, onImport, onAssetsSynced, onStop };
};
const applicationLifecyclePluginDefinition = {
    id: 'applicationLifecyclePlugin',
    type: 'plugin',
    factory: applicationLifecyclePlugin,
    dependencies: ['port', 'lockedAtom', 'lockHistoryAtom', 'restoreAtom'],
};
export default applicationLifecyclePluginDefinition;
